<div class="ui modal" id="BettingSlip_Calculator_Modal" style="position:absolute;bottom:15%;left:-82%;">

  <div class="header">
    <span>{{"ENTER_STAKE" | t}}</span>
    <button style="float:right;background-color: white;border: 1px solid;" class="circular ui icon button"
            (click)="CalculatorModal_Close()">
      <i class="remove link icon"></i>
    </button>
  </div>

  <div class="calculatorContainer">
    <div class="leftArea">
      <div class="moneyButton" (click)="CalculatorModal_ChangeValue(item,true)" *ngFor="let item of moneyList">{{item}}</div>
    </div>
    <div class="rightArea">
      <div class="content">
        <div class="ui fluid big input">
          <input placeholder="0" id="Calculator_Input" style="text-align:right;height:70px;font-size:40px" type="text"
                 value="{{this.Calculator_Input_Value}}">
        </div>
      </div>
      <div class="content">
        <div class="ui grid segment">
          <table class="ui table" id="BettingSlip_Calculator_Modal_ButtonTable">
            <tr>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(1)">1
                </button>
              </td>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(2)">2
                </button>
              </td>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue('3')">3
                </button>
              </td>
              <td rowspan="2" class="four wide">
                <button class="ui fluid button" style="height:170px;width:70px" (click)="CalculatorModal_Cancel()">
                  C
                </button>
              </td>
            </tr>
            <tr>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(4)">4
                </button>
              </td>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(5)">5
                </button>
              </td>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(6)">6
                </button>
              </td>
            </tr>
            <tr>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(7)">7
                </button>
              </td>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(8)">8
                </button>
              </td>
              <td class="four wide">
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue(9)">9
                </button>
              </td>
              <td rowspan="2" class="four wide">
                <button class="ui fluid orange button" style="height:170px;width:70px" (click)="CalculatorModal_Ok()">
                  OK
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <button class="circular ui icon button terminalButton" id="BettingSlip_Calculator_Modal_ZeroButton"
                        (click)="CalculatorModal_ChangeValue(0)">
                  0
                </button>
              </td>
              <td>
                <button class="BettingSlip_Modal_Calculator_CircleButton terminalButton"
                        (click)="CalculatorModal_ChangeValue('.')">.
                </button>
              </td>

            </tr>

          </table>
        </div>
      </div>
    </div>

  </div>
</div>
